export class DadosSeparacaoTransporte {
  idCupom: string;
  cubagem: string;
  observacao: string;
  idTransportadora: number;
  tipoEntrega: number;
}
